var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Job Applications",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5j8vhae65a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by64xc30ub",
    y1: 1,
    y2: 0,
    xlinkHref: "#5j8vhae65a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "80jh86wt6c",
    x1: 1.047,
    y1: 0.5,
    x2: -1.311,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4vbyjs654d",
    x1: 0.5,
    y1: 0.336,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#fe4600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e51400"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 32,
    cy: 32,
    r: 32,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 13",
    d: "M0 5.063V1.338a1.338 1.338 0 1 1 2.676 0v3.725a1.338 1.338 0 0 1-2.676 0z",
    transform: "translate(31.121 7.559)",
    style: {
      fill: "url(#5j8vhae65a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 14",
    d: "M0 5.063V1.338a1.338 1.338 0 1 1 2.676 0v3.725a1.338 1.338 0 0 1-2.676 0z",
    transform: "rotate(-30 29.932 -27.716)",
    style: {
      fill: "url(#5j8vhae65a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 16",
    d: "M0 5.063V1.338a1.338 1.338 0 1 1 2.676 0v3.725a1.338 1.338 0 0 1-2.676 0z",
    transform: "rotate(-60 21.324 2.244)",
    style: {
      fill: "url(#5j8vhae65a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 17",
    d: "M0 5.063V1.338a1.338 1.338 0 1 1 2.676 0v3.725a1.338 1.338 0 0 1-2.676 0z",
    transform: "rotate(-120 31.905 -3.227)",
    style: {
      fill: "url(#by64xc30ub)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 15",
    d: "M0 5.063V1.338a1.338 1.338 0 1 1 2.676 0v3.725a1.338 1.338 0 0 1-2.676 0z",
    transform: "rotate(-150 24.175 2.523)",
    style: {
      fill: "url(#by64xc30ub)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 155",
    transform: "translate(22 23.025)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 180",
    width: 6.598,
    height: 2.034,
    rx: 1.017,
    transform: "translate(3.395 9.316)",
    style: {
      fill: "url(#80jh86wt6c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 184",
    width: 6.598,
    height: 2.034,
    rx: 1.017,
    transform: "translate(3.395 4.903)",
    style: {
      fill: "url(#80jh86wt6c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 181",
    width: 13.359,
    height: 2.034,
    rx: 1.017,
    transform: "translate(3.395 13.728)",
    style: {
      fill: "url(#80jh86wt6c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 183",
    width: 12.399,
    height: 2.034,
    rx: 1.017,
    transform: "translate(3.395 18.14)",
    style: {
      fill: "url(#80jh86wt6c)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72",
    d: "M18.66 25.575H.96a.96.96 0 0 1-.96-.96V.96A.96.96 0 0 1 .96 0h11.515a.96.96 0 0 1 .959.96v4.782l5.238.065a.96.96 0 0 1 .948.959v17.849a.96.96 0 0 1-.96.96zM1.919 23.656H17.7V7.713l-5.238-.064a.96.96 0 0 1-.948-.959V1.919h-9.6z",
    style: {
      fill: "url(#4vbyjs654d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7",
    d: "M.929 1.475a.956.956 0 0 1-.654-.257l-5.969-5.556a.96.96 0 0 1-.049-1.356.96.96 0 0 1 1.356-.049l5.97 5.556a.96.96 0 0 1-.654 1.662z",
    transform: "translate(17.742 6.159)",
    style: {
      fill: "#ff4800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 73",
    d: "M12.422 2.165v4.221h5.432z",
    transform: "translate(.279 .049)",
    style: {
      fill: "#ff4800"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplications);
export default __webpack_public_path__ + "static/media/job-applications.21eb1c87a361700eca3e5a14d68baf7b.svg";
export { ForwardRef as ReactComponent };